// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/infinity.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/checkmark-pricing.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zervant-icon {
  background-size: contain;
  background-repeat: no-repeat;
  -ms-flex-negative: 0;
      flex-shrink: 0;
}
.zervant-icon--infinity {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 12px;
  height: 6px;
}
.zervant-icon--checkmark-pricing {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  width: 12px;
  height: 12px;
}
.zervant-icon--question-mark {
  width: 17px;
  height: 17px;
}
.zervant-icon--premium-star-green {
  width: 16px;
  height: 16px;
}
.zervant-icon--premium-star-green .img {
  height: 100%;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/client/components/Icons/Icon.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,4BAAA;EACA,oBAAA;MAAA,cAAA;AACF;AAAE;EACE,yDAAA;EACA,WAAA;EACA,WAAA;AAEJ;AACE;EACE,yDAAA;EACA,WAAA;EACA,YAAA;AACJ;AACE;EACE,WAAA;EACA,YAAA;AACJ;AAEE;EACE,WAAA;EACA,YAAA;AAAJ;AACI;EACE,YAAA;EACA,WAAA;AACN","sourcesContent":[".zervant-icon {\n  background-size: contain;\n  background-repeat: no-repeat;\n  flex-shrink: 0;\n  &--infinity {\n    background-image: url('./assets/infinity.png');\n    width: 12px;\n    height: 6px;\n  }\n\n  &--checkmark-pricing {\n    background-image: url('./assets/checkmark-pricing.png');\n    width: 12px;\n    height: 12px;\n  }\n  &--question-mark {\n    width: 17px;\n    height: 17px;\n  }\n\n  &--premium-star-green {\n    width: 16px;\n    height: 16px;\n    .img {\n      height: 100%;\n      width: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
